const fieldSizes = {
  EXTRA_SMALL: 'xs',
  SMALL:       's',
  STANDARD:    'std',
  LARGE:       'l',
  EXTRA_LARGE: 'xl',
  ADAPTIVE:    'viewport',
};

const fieldSizesList = [
  { label: 'Extra small', submitValue: fieldSizes.EXTRA_SMALL },
  { label: 'Small', submitValue: fieldSizes.SMALL },
  { label: 'Standard', submitValue: fieldSizes.STANDARD },
  { label: 'Large', submitValue: fieldSizes.LARGE },
  { label: 'Extra large', submitValue: fieldSizes.EXTRA_LARGE },
  { label: 'Adaptive', submitValue: fieldSizes.ADAPTIVE },
];

const fieldSizesAll = _.values(fieldSizes);

export { fieldSizes, fieldSizesList, fieldSizesAll };

export default fieldSizes;
